<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="md" :visible="modal.show" :data="model" scrollable
                   :title="model.uuid ? $t(`Update Miscellaneous Charge`) : $t(`Create New Miscellaneous Charge`)"
                   @show="onShow"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" modal-class="mobile-full-screen">
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="description"/>
        </div>
        <div class="col-md-12">
          <input-widget type="text" :model="model" attribute="comment"/>
        </div>
        <div class="col-md-6">
          <currency-input-widget :rules="amountRule" :model="model" attribute="amount" :disabled="model.percentage !== null"/>
        </div>
        <div class="col-md-6">
          <percentage-input-widget :rules="percentageRule" :model="model" attribute="percentage" :disabled="model.amount !== null"/>
        </div>
        <div class="col-md-6">
          <input-widget :model="model" attribute="taxable" type="checkbox" is-switch/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";
  import InventoryMiscChargeModel
    from "@/modules/inventory/view/dashboard/inventory-misc-charges/InventoryMiscCharge.model";
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import CurrencyInputWidget from "@/core/widgets/CurrencyInputWidget";
  import PercentageInputWidget from "@/core/widgets/PercentageInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('inventory');

  export default {
    name: "InventoryMiscChargeModal",
    components: {
      PercentageInputWidget,
      CurrencyInputWidget,
      InputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new InventoryMiscChargeModel(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.inventoryMiscChargeModal,
        editObject: state => state.inventoryMiscChargeModal.object
      }),
      amountRule() {
        return !this.model.percentage ? 'required|min_value:0.1' : 'min_value:0.1'
      },
      percentageRule() {
        return !this.model.amount ? 'required|min_value:0.1|max_value:100' : 'min_value:0.1|max_value:100'
      }
    },
    watch: {
      editObject() {
        if (this.editObject && (this.editObject.uuid || this.editObject.inventory_uuid)) {
          this.model = new InventoryMiscChargeModel(this.editObject)
        }
      },
    },
    methods: {
      ...mapActions(['hideInventoryMiscChargeModal', 'createInventoryMiscCharge', 'updateInventoryMiscCharge']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new InventoryMiscChargeModel();
        this.hideInventoryMiscChargeModal();
      },
      async onSubmit() {
        let response;

        if (!this.model.uuid) {
          response = await this.createInventoryMiscCharge(this.model);
        } else {
          response = await this.updateInventoryMiscCharge(this.model);
        }
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.hideInventoryMiscChargeModal();
          if (!this.model.uuid) {
            this.$toast('success', this.$t('Invoice miscellaneous charge was successfully created'));
          } else {
            this.$toast('success', this.$t('Invoice miscellaneous charge was successfully updated'));
          }
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
    }
  }
</script>

<style scoped>

</style>
